import { OuterMeasurementsComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
/**
 * Remove OuterMeasurementsComponent from corner frame (handled separatley in BillyEntityApi)
 */
export class CornerFrameMeasurementsSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'CornerFrameMeasurementsSystem', ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.coreApi = coreApi;
    }
    onAdd(entity, newComponent) {
        if (this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) &&
            this.placedInCorner(newComponent)) {
            this.removeOuterMeasurementsComponent(entity);
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (!this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) ||
            this.placedInCorner(oldComponent) === this.placedInCorner(newComponent)) {
            return;
        }
        if (this.placedInCorner(newComponent)) {
            this.removeOuterMeasurementsComponent(entity);
        }
        if (this.placedInCorner(oldComponent)) {
            this.addOuterMeasurementsComponent(entity);
        }
    }
    onRemove(entity, oldComponent) {
        if (this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) &&
            this.placedInCorner(oldComponent)) {
            this.addOuterMeasurementsComponent(entity);
        }
    }
    placedInCorner(guestConnection) {
        return (guestConnection.highestPriorityConnection &&
            guestConnection.highestPriorityConnection.guestConnector.key === 'wall-corner');
    }
    addOuterMeasurementsComponent(frameAssembly) {
        const frame = this.coreApi.entities.getChildrenWithProductType(frameAssembly, ProductType.BILLY_FRAME)[0];
        frame?.addComponent(new OuterMeasurementsComponent());
    }
    removeOuterMeasurementsComponent(frameAssembly) {
        const frame = this.coreApi.entities.getChildrenWithProductType(frameAssembly, ProductType.BILLY_FRAME)[0];
        frame?.removeComponent(OuterMeasurementsComponent.id);
    }
}
//# sourceMappingURL=CornerFrameMeasurementsSystem.js.map